export default __webpack_public_path__ + "static/media/smile11.c63eed33.jpg";